/// <amd-module name="Build/SourceProviders/ExternalUnknown" />
import { Change } from "Build/Client/Contracts/Build";

import { Base } from "Build/SourceProviders/Base";
import { RepositoryTypes, IBranchInfo, ICommitInfo } from "Build/SourceProviders/Common";
import * as Resources from "Build/SourceProviders/Resources";
import { IVCNavigationService } from 'VC/Common/Navigation';

export class ExternalUnknown extends Base {
    public getKey() {
        return RepositoryTypes.ExternalUnknown;
    }

    public getName() {
        return Resources.ExternalUnknown;
    }

    public fetchBranchLink(info: IBranchInfo) {
        return Promise.resolve(this._getBranchLink(info));
    }

    public fetchCommitLink(info: ICommitInfo) {
        return Promise.resolve(this._getCommitLink(info));
    }

    public getBranchLink(info: IBranchInfo) {
        return this._getBranchLink(info);
    }

    public getCommitLink(info: ICommitInfo) {
        return this._getCommitLink(info);
    }

    protected _getBranchLink(info: IBranchInfo, service?: IVCNavigationService) {
        if (info.links) {
            const link: { href: string } = info.links["sourceVersionDisplayUri"];
            if (link && link.href) {
                return link.href;
            }
        }

        return "";
    }

    protected _getCommitLink(info: ICommitInfo, service?: IVCNavigationService) {
        if (info.displayUri) {
            return info.displayUri;
        }

        return "";
    }
}
